import type { TaskEither } from 'fp-ts/lib/TaskEither';
import { fetchApi, fetchTE } from 'utils/request';

export const listComputeClustersTE = <E = CF.API.ApiError>(
  { userId, params = '' }: { userId?: string; params?: string },
  onRejected?: (e: CF.API.ApiError) => E,
): TaskEither<E, CF.API.Compute.ListComputeClusterResponse> =>
  fetchTE<CF.API.Compute.ListComputeClusterResponse, E>(
    {
      path: `/api/_api/v2${userId ? `/users/${userId}` : ''}/compute_clusters${params ? `?${params}` : ''}`,
      method: 'GET',
    },
    onRejected,
  );

export const apiListComputeClusters = ({
  userId,
  params = '',
}: {
  userId?: string;
  params?: string;
}): Promise<CF.API.Compute.ListComputeClusterResponse> =>
  fetchApi<CF.API.Compute.ListComputeClusterResponse>({
    path: `/api/_api/v2${userId ? `/users/${userId}` : ''}/compute_clusters${params ? `?${params}` : ''}`,
    method: 'GET',
  });
